import http from './http'

class Token {
  save (tenantAuthenticationToken) {
    return http.post('/tenant_authentication_tokens', { tenant_authentication_token: tenantAuthenticationToken })
  }

  remove (id) {
    return http.delete(`/tenant_authentication_tokens/${id}`)
  }
}

export default new Token()



// WEBPACK FOOTER //
// ./src/services/token.js